import React, { useEffect, useRef, useState } from 'react';
import { bool, func, instanceOf, number } from 'prop-types';

import moment from 'moment';

import classes from './ElapsedTime.module.css';

const FormattedDate = 'M/D/YY h:mm A';

/**
 * Adapted from:
 *
 *   https://overreacted.io/making-setinterval-declarative-with-react-hooks/
 */
function useInterval(callback, { interval, leading }) {
    const savedCallback = useRef();
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
    useEffect(() => {
        const tick = () => savedCallback.current();
        if (interval === null) {
            return;
        }
        if (leading) {
            // Invoke on the leading edge of the timeout
            tick();
        }
        const id = setInterval(tick, interval);
        return () => clearInterval(id);
    }, [interval]);
}

const ElapsedTime = ({ dateTime, interval, leading, render }) => {
    let [elapsedTime, setTime] = useState('');
    let dateTimeISO = null;
    if (dateTime) {
        dateTimeISO  = dateTime.toISOString();
    }
    useInterval(() => {
        if (!dateTime) {
            setTime('');
            return;
        }
        const dateTimeValue = moment(dateTime);
        const diffDays = dateTimeValue.diff(Date.now(), 'days');
        if (diffDays !== 0) {
            setTime(dateTimeValue.format(FormattedDate));
        } else {
            setTime(dateTimeValue.fromNow());
        }
    }, { interval, leading });
    return (
        <time className={classes.root} dateTime={dateTimeISO}>
            {render(elapsedTime)}
        </time>
    );
};

ElapsedTime.defaultProps = {
    interval: 1000,
    leading:  true,
    render:   (value) => value
};

ElapsedTime.propTypes = {
    dateTime: instanceOf(Date),
    interval: number,
    leading:  bool,
    render:   func
};

export default ElapsedTime;
